export const OfficeConnectorsState = {
	url: '/connectors?id&logout',
	template: '<office-connectors-page></office-connectors-page>',
	params: {id: null, logout: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeConnectorsPageMod" */
			'@Containers/office-connectors-page/office-connectors-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
